<template>
    <div class="tutorialize-button hidden-xs" @click="startTutorial">
        {{ label }}
    </div>
</template>

<style lang="scss">
    @import '../../sass/_global_variables.scss';

    .tutorialize-button {
        position: fixed;
        bottom: 0;
        right: 100px;
        padding: 10px 20px;
        background-color: $background-gray;
        border: 1px solid $border-dark-gray;
        color: $dark-blue;
        font-weight: bold;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        cursor: pointer;
        z-index: 1000;
    }
</style>

<script>
export default{
    props: {
        tutorial: { default: null },
        user_id: { default: null },
        label: { default: 'Start Tutorial' }
    },

    methods: {
        beforeTutorial() {
            this.$emit('on_start');
        },

        afterTutorial() {
            this.$emit('on_stop');
        },

        startTutorial() {
            var vm = this;

            if (this.user_id) {
                _t.push({ user_id: this.user_id });
            }

            if (this.tutorial) {
                _t.push({
                    start: this.tutorial,
                    config: {
                        force: true,
                        onStart: this.beforeTutorial,
                        onStop: this.afterTutorial
                    }
                });
            }
        }
    }
}


</script>



// WEBPACK FOOTER //
// tutorialize.vue?513265b1